module.exports = __webpack_public_path__ + "img/select-infield-mezzanine.093d44e9.svg";